import { useState } from 'react'
import { Tabs, Tab, KpiCard } from '@/components/ui'
import { Radio, Inbox, BookOpen, GraduationCap, Settings, MessageCircle, Users, Clock, Percent, Signal } from 'lucide-react'
import { Supervision } from './Supervision'
import { Bandeja } from './Bandeja'
import { KnowledgeBase } from './KnowledgeBase'
import { Aprendizaje } from './Aprendizaje'
import { ConfigCopilot } from './Config'

type TabKey = 'supervision' | 'bandeja' | 'kb' | 'aprendizaje' | 'config'

export function AutoservicioPage() {
  const [tab, setTab] = useState<TabKey>('supervision')

  return (
    <div className="space-y-5">
      <header>
        <div className="text-xs uppercase tracking-widest text-emerald-500 font-semibold">WhatsApp · Autoservicio IA</div>
        <h1 className="font-display text-3xl text-navy-700 leading-tight">Copilot 24/7 — autoservicio al cliente</h1>
        <p className="text-sm text-slate-500 max-w-2xl mt-1">
          Clientes consultan saldo, cuentas de pago, detalle de crédito o envían comprobantes 24/7. El copilot responde con datos parametrizados de la BD. Nunca inventa saldos.
        </p>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        <KpiCard label="Chats del día" value="42" sub="hoy · lun" icon={<MessageCircle className="w-3.5 h-3.5" />} />
        <KpiCard label="Mensajes atendidos" value="316" sub="in + out" icon={<Signal className="w-3.5 h-3.5" />} />
        <KpiCard label="Resueltos por bot" value="38" sub="90% auto" color="emerald" icon={<Percent className="w-3.5 h-3.5" />} />
        <KpiCard label="Clientes únicos" value="34" sub="distintos" icon={<Users className="w-3.5 h-3.5" />} />
        <KpiCard label="TTR promedio" value="18s" sub="tiempo primera resp." icon={<Clock className="w-3.5 h-3.5" />} color="amber" />
      </div>

      <Tabs value={tab} onChange={v => setTab(v as TabKey)} color="emerald">
        <Tab value="supervision" icon={<Radio className="w-4 h-4" />}>Supervisión</Tab>
        <Tab value="bandeja" icon={<Inbox className="w-4 h-4" />}>Bandeja</Tab>
        <Tab value="kb" icon={<BookOpen className="w-4 h-4" />}>Base de conocimiento</Tab>
        <Tab value="aprendizaje" icon={<GraduationCap className="w-4 h-4" />}>Aprendizaje</Tab>
        <Tab value="config" icon={<Settings className="w-4 h-4" />}>Config copilot</Tab>
      </Tabs>

      <div className="view-transition">
        {tab === 'supervision' && <Supervision />}
        {tab === 'bandeja' && <Bandeja />}
        {tab === 'kb' && <KnowledgeBase />}
        {tab === 'aprendizaje' && <Aprendizaje />}
        {tab === 'config' && <ConfigCopilot />}
      </div>
    </div>
  )
}
